import React, { Component } from 'react';
import styled from 'styled-components';
import { FaBars } from 'react-icons/fa';
import { Logo } from '../../common/components';
import UserDropdown from './UserDropdown';
import Tenant from './Tenant';
import { withTenant } from '../../context/tenantConfig';
import { ClickContext } from '../context';

const Navbar = styled.div`
  width: 100%;
  background-color: #ffffff;
  position: fixed;
  z-index: 999;
  top: 0;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid #f0f0f0;
`;

const Container = styled.div`
  width: 96%;
  margin: 0 auto;
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  position: relative;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`;

// Hidden on desktop — the sidebar is always visible there, so there's
// nothing to open. Only shown once the layout switches to the mobile
// off-canvas drawer.
const MenuButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin-right: 2px;
  border-radius: 8px;
  color: #1f2937;
  flex-shrink: 0;
  transition: background 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const BellButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
  position: relative;
  transition: background 0.2s ease;

  &:hover {
    background: #f5f5f5;
  }

  svg {
    color: #828282;
  }
`;

class Header extends Component {
  static contextType = ClickContext

  render() {
    // The switcher is shown to any user who actually has more than one
    // tenant to switch between — not gated by role. getTenantsByUser()
    // (backing this list server-side) and switchTenant() (which the
    // dropdown calls) already scope everything to tenants this specific
    // user belongs to, so this is just mirroring that on the UI side.
    const tenantList = (this.props.tenant && this.props.tenant.tenants) || []
    const hasMultipleTenants = tenantList.length > 1
    const { toggleMobileSidebar } = this.context || {}

    return (
      <Navbar>
        <Container>
          <LeftSection>
            <MenuButton
              type="button"
              onClick={toggleMobileSidebar}
              aria-label="Open menu"
            >
              <FaBars size={18} />
            </MenuButton>
            <Logo style={{ width: 'auto', maxWidth: '150px', height: '60px' }} />
          </LeftSection>
          <RightSection>
            {hasMultipleTenants && <Tenant />}
            <UserDropdown />
          </RightSection>
        </Container>
      </Navbar>
    );
  }
}

export default withTenant(Header);